import { pushFormattedGtmEvent } from '@/logic/metrika/helpers'
import type { IFormattedGtmEventPayload } from '@/logic/metrika/interfaces'

export const openArticleClicked = (gtmEventPayload: IFormattedGtmEventPayload) => () => {
  pushFormattedGtmEvent(gtmEventPayload)
}
